import React, { Fragment, useEffect } from "react"
import cal from "clsx"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import TextField from "@material-ui/core/TextField"
import InputAdornment from "@material-ui/core/InputAdornment"
import IconButton from "@material-ui/core/IconButton"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import AccountCircleIcon from "@material-ui/icons/AccountCircle"
import Button from "@material-ui/core/Button"
import { useAssign } from "Hooks/basic"
import { useLogin } from "Hooks/user"
import { useLoginStyle } from "./style"

const logoUrl = "https://i-young.guokr.net/FjgPqn3uO8KEUyO5ALf0-gVV-zgl"
const formShowDelay = 1000

// 使用as断言variant和margin属性的类型，不然ts推论结果为string类型导致报错
const textFieldCommonProps = {
    variant: "outlined" as "outlined",
    margin: "normal" as "normal",
    required: true,
    fullWidth: true,
    spellCheck: false,
}

export default function SignIn() {
    const classes = useLoginStyle()
    const {
        object: formStatus,
        handleChange: handleChangeFormStatus,
    } = useAssign({
        showPassword: false,
        showForm: false,
    })
    // 登录弹窗出现动画
    const animateShowForm = () => {
        setTimeout(() => {
            handleChangeFormStatus({
                showForm: true,
            })
        }, formShowDelay)
    }
    // 是否显示密码
    const handleClickShowPassword = () => {
        handleChangeFormStatus({
            showPassword: formStatus.showPassword,
        })
    }
    // 回车提交表单
    const handleEnterSubmit = async (event: React.KeyboardEvent) => {
        if (event.keyCode === 13) {
            await handleSubmit()
        }
    }
    const {
        username, password,
        error, helperText,
        handleChangePassword,
        handleChangeUsername,
        handleSubmit,
    } = useLogin()
    useEffect(() => {
        animateShowForm()
        // eslint-disable-next-line
    }, [])
    return (
        <Fragment>
            <div className={classes.backgroundImage} />
            <Container
                component="main"
                maxWidth="xs"
                className={cal(
                    formStatus.showForm ? classes.containerShow : classes.container,
                )}
            >
                <div className={classes.paper}>
                    <Grid container justify="space-around" alignItems="center">
                        <Grid item>
                            <img className={classes.logo} src={logoUrl} alt="" />
                        </Grid>
                        <Grid>
                            <Typography component="h1" variant="h5" color="textSecondary">
                                用户登录
                            </Typography>
                        </Grid>
                    </Grid>
                    <form className={classes.form}>
                        <TextField
                            className={classes.input}
                            value={username}
                            onChange={handleChangeUsername}
                            onKeyUp={handleEnterSubmit}
                            error={error && error.username}
                            helperText={helperText && helperText.username}
                            label="用户名"
                            {...textFieldCommonProps}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton tabIndex={-1}>
                                            <AccountCircleIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            className={classes.input}
                            value={password}
                            onChange={handleChangePassword}
                            onKeyUp={handleEnterSubmit}
                            autoComplete="true"
                            error={error && error.password}
                            type={formStatus.showPassword ? "text" : "password"}
                            helperText={helperText && helperText.password}
                            label="密码"
                            {...textFieldCommonProps}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            tabIndex={-1}
                                            onClick={handleClickShowPassword}
                                        >
                                            {formStatus.showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </form>
                    <Button
                        type="submit" fullWidth variant="contained"
                        color="primary" className={classes.submit}
                        onClick={handleSubmit}
                    >
                        登录
                    </Button>
                </div>
            </Container>
        </Fragment>
    )
}
